import { env } from './env';
export var envMockedApi = function () { return env.VITE_MOCKED_API === 'true'; };
export var isPragmaRedirect = function () { return env.VITE_PRAGMA_PROCESS_REDIRECT === 'true'; };
export var isPanelUrlIncludesEventOrigin = function (origin) { var _a; return (_a = env.VITE_PANEL_URL) === null || _a === void 0 ? void 0 : _a.includes(origin); };
export var isEventOriginIncludesLiberisUrl = function (origin) { var _a; return (_a = env.VITE_LIBERIS_IFRAME_URL) === null || _a === void 0 ? void 0 : _a.includes(origin); };
